'use client';

// ПИЛЮЛЯ-ПЕРЕКЛЮЧАТЕЛЬ ЦЕЛИ «Подписка / Продажа» — ОДИН компонент на лендинг (второй экран, goal-scenes) и стопку
// «Не удалось разобраться?» кабинета (QUICK-START §2.3: «как на лендосе, сверху переключатели… как пилюля»).
// Разметка и вид — те же, что были у лендинга (`.goal-seg` / `.goal-tab`, kit.css); копий не заводить.
import type { ReactNode } from 'react';
import { KBareButton } from './button';
import { cx } from './cx';

export interface GoalSegOption<K extends string> {
  key: K;
  label: string;
  /** Метка у слова пилюли (QUICK-START §11.31: наклейка «Pro» у «Продажи» на бесплатном) — span, не кнопка. */
  mark?: ReactNode;
}

export function GoalSeg<K extends string>({
  value,
  options,
  onChange,
  ariaLabel,
  fill,
  className,
}: {
  value: K;
  options: readonly GoalSegOption<K>[];
  onChange: (key: K) => void;
  ariaLabel: string;
  /** Во всю ширину (стопка кабинета): таблетки делят ряд поровну. */
  fill?: boolean;
  className?: string;
}) {
  return (
    <div className={cx('goal-seg', fill && 'goal-seg--fill', className)} role="tablist" aria-label={ariaLabel}>
      {options.map((o) => (
        <KBareButton key={o.key} role="tab" aria-selected={o.key === value} className="goal-tab" onClick={() => onChange(o.key)}>
          {o.label}
          {o.mark ?? null}
        </KBareButton>
      ))}
    </div>
  );
}
